import { UserContext } from 'actions/UserActions';

export const getMatchingWebsiteURL = (userContext: UserContext, themeKey: string): string =>
  userContext.has_wedding_account
    ? `/wedding/manage/website/design/${themeKey}`
    : `/wedding-planning/website/design/${themeKey}`;

export const getCardTypeFromSuiteName = (suiteName: string): string =>
  suiteName.split('-')[0].trim();

export const getSuiteFrontImageURL = (suite: any, selectedColor: string): string =>
  suite.colors.find(({ value }: { value: string }) => value === selectedColor)
    ?.plp_front_image_url || suite.colors[0].plp_front_image_url;

export const getShortSuiteName = (suiteName: string) => suiteName.split('-')[1].trim();

export const getPLPURLWithFilters = (
  suiteUUID: string,
  motifs: string[],
  hasCustomPhoto: boolean
) => {
  const motifParam = motifs.join('--').toLowerCase();
  return `${window.location.href.split(suiteUUID)[0]}shop/${motifParam}/${
    hasCustomPhoto ? '?features=customphoto' : '?features=nocustomphoto'
  }`;
};
